<!-- Hero Image -->
<div class="hero-image">
  <div class="hero-text">
    <h1>Austin Smyth</h1>
    <p>This is my Website</p>
  </div>
</div>
